<template>
  <div id="top-menu">
    <TenderHeader v-if="isTenderPage($route)" :project="project" />
    <IncomingTenderHeader v-else-if="isIncomingTenderPage($route)" :project="project" />
    <ProjectHeader
      v-else
      :project="project"
      :is-tender-list="currentRouteMatcher('tenders', $route)"
      @refresh-project-info="$emit('refresh-project-info')"
    />

    <TendersNavigation v-if="currentRouteMatcher('tenders', $route)" :project="project" />
    <ProjectNavigation
      v-else
      :project="project"
      :is-tender-type-page="tenderTypePage"
      :show-scroll-actions="isIncomingTenderPage($route)"
    />
  </div>
</template>

<script>
  import ProjectHeader from '@/containers/top-menu/header/Project';
  import ProjectNavigation from '@/containers/top-menu/navigation/index';
  import TendersNavigation from '@/components/tenders/TendersNavigation';
  import { isTenderPage, isIncomingTenderPage, currentRouteMatcher } from '@/utils/route-matcher';
  import TenderHeader from '@/containers/top-menu/header/tender/general-contractor/TenderHeader';
  import IncomingTenderHeader from '@/containers/top-menu/header/tender/contractor/IncomingTenderHeader';

  export default {
    name: 'ProjectTopMenu',
    components: {
      IncomingTenderHeader,
      TenderHeader,
      ProjectNavigation,
      ProjectHeader,
      TendersNavigation,
    },
    props: {
      project: Object,
      isPublic: Boolean,
    },
    computed: {
      tenderTypePage() {
        return this.isTenderPage(this.$route) || this.isIncomingTenderPage(this.$route);
      },
    },
    methods: {
      isTenderPage,
      isIncomingTenderPage,
      currentRouteMatcher,
    },
  };
</script>
<style lang="scss">
  @import 'src/styles/components/top-menu';
</style>
